module.exports = ".login-form.required .control-label:after {\n  color: red;\n  content: \"*\";\n  position: absolute; }\n"